import { Deserializable } from '../protocols/deserializable';

export class VbAccountActivityBreakdown implements Deserializable {
  public openingBalance!: number;
  public depositsAndTransfersIn!: number;
  public earnings!: number;
  public payments!: number;
  public other!: number;
  public currentBalance!: number;

  public onDeserialize() {}
}
